import { render, staticRenderFns } from "./publicVideoPlayer.vue?vue&type=template&id=07638e9c&"
import script from "./publicVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./publicVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./publicVideoPlayer.vue?vue&type=style&index=0&id=07638e9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports